import React, { useEffect } from "react";
import { BannedIpInterface } from "src/store/mine_craft/bannedIpsSlice";

import { Button, Form, Input } from "antd";

interface propsInterface {
  params?: BannedIpInterface | undefined;
  onFinish: Function;
}

const _FormEdit = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='reason' label="Reason" rules={[{ required: true, message: 'Reason is required' }]}>
        <Input.TextArea placeholder='Ban reason' rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _FormEdit;
